<template>
    <header v-if="!isMobile && possuiLogoEsquerdaTopo" :class="{ siteHeaderRJI: isRJI }" class="siteHeader">
        <div class="logo" >
            <img :src="logoUrl" :class="{ logoHeader_rji : isRJI, logoHeader: !isRJI }"  />
        </div>
    </header>
    <div class="site-header" v-if="possuiBotaoCadastroTopo || isMobile">
        <nav class="navigation">
            <ul>
                <li>
                    <button type="button" @click="irParaCadastroInicial" class="submit-button-login">
                        Cadastro
                    </button>
                </li>
            </ul>
        </nav>
    </div>

    <div class="container"
        :class="
        { 
            containerDesktop: !isMobile && !centralizarLogin, 
            containerRJI: !isMobile && isRJI,
            containerActual: !isMobile && isActual
        }">

        <div v-if="!openToken" class="header">
            <div v-if="!isRJI && !isActual" class="logo">
                <img :src="logoUrl" style="width: 100%; height: 100%;" />
            </div>
            <h2 v-if="!isGenial">Selecione o tipo de conta</h2>
        </div>

        <div v-if="openToken" class="header">
            <p style="cursor: pointer; margin-top: 10px; align-self: flex-start; cursor: pointer; display: inline-flex;"
                @click="voltar()"><img src="@/assets/arrow.svg" /> Voltar</p>
            <div>
                <img src="@/assets/cadeado_com_fundo.svg" />
            </div>
            <h2 style="color: #00235C; font-size: 30px;">Chave de acesso</h2>
        </div>
        <div class="tabs-container" v-if="!openToken">
            <div class="tab-item" v-if="verificarTipoCliente('1')" :class="{ active: tab === 1 }">
                <a href="javascript:;" class="link" @click="selectTab(1)">
                    PESSOA FÍSICA
                </a>
                <div class="underline"></div>
            </div>
            <div class="tab-item" v-if="verificarTipoCliente('2')" :class="{ active: tab === 2 }">
                <a href="javascript:;" class="link" @click="selectTab(2)">
                    PESSOA JURÍDICA
                </a>
                <div class="underline"></div>
            </div>
            <div class="tab-item" v-if="verificarTipoCliente('3')" :class="{ active: tab === 3 }">
                <a href="javascript:;" class="link" @click="selectTab(3)">
                    FUNDOS
                </a>
                <div class="underline"></div>
            </div>
        </div>
        <div class="header" style="margin-top: 0; padding-top: 20px;">
            <p v-if="!openToken" style="margin-top: 0;">{{mensagemLoginHeader}}</p>

            <p v-if="openToken" style="margin-top: 0;">
                Para continuar, digite o código que acabamos de enviar para o seu e-mail.
            </p>
        </div>
        <form v-if="tab === 1 && !openToken" class="form" @submit.stop.prevent="sendLogin">
            <div class="input-field">
                <label for="email">E-mail ou CPF</label>
                <input type="text" v-model="loginSession.Usuario" class="field" autocomplete="off"
                    @click.stop.prevent="clear" :class="{ erroBorder: erro }" ref="emailField1" />
            </div>
            <div class="input-field">
                <label for="password">Senha</label>
                <input type="password" v-model="loginSession.Senha" class="field" autocomplete="off"
                    @click.stop.prevent="clear" :class="{ erroBorder: erro }" />
            </div>
            <button type="button" @click="reenviarEmail" v-if="habilitarReenviarEmail"
                class="button buttonReenviarEmail">Reenviar e-mail para ativação</button>
            <router-link class="forgot-password" to="/RecuperarSenha">Esqueci minha senha</router-link>
            <button type="submit" :disabled="disableBtnLogin" :class="{ disabledBtn: disableBtnLogin }"
                class="submit-button-login">
                <span class="btnText" v-if="!disableBtnLogin">Entrar</span>
                <div class="loadingDots" v-if="disableBtnLogin">
                    <span class="dot">.</span>
                    <span class="dot2">.</span>
                    <span class="dot3">.</span>
                </div>
            </button>
        </form>
        <form v-if="tab === 2 && !openToken" class="form" @submit.stop.prevent="sendLogin">
            <fieldset :disabled="loading" style="border: none">
                <div class="input-field">
                    <label for="email">E-mail ou CNPJ</label>
                    <input type="text" v-model="loginSession.Usuario" v-if="nomeEmpresa != 'GENIAL' || configuracaoApelido == 'S'" class="field"
                        autocomplete="off" @click.stop.prevent="clear" @blur="handleEmailBlur"
                        :class="{ erroBorder: erro && nomeEmpresa != 'GENIAL', erroBorderVerifyRegister: erro && nomeEmpresa == 'GENIAL' }"
                        ref="emailField2" />
                    <input type="text" v-model="loginSession.Usuario" v-if="nomeEmpresa == 'GENIAL' && configuracaoApelido == 'N'" ref="emailField2" class="field"
                        autocomplete="off" @click.stop.prevent="clear" :class="{ erroBorderVerifyRegister: erro }" />
                </div>
                <div class="input-field" v-if="configuracaoApelido == 'S'">
                    <label for="apelido">Selecione o apelido da conta para logar</label>
                    <select v-model="loginSession.Apelido" class="field" :class="{ erroBorder: erro }"
                        style="margin-bottom: 20px;" :disabled="isApelidoDisabled">
                        <option v-for="apelido in apelidos" :key="apelido" :value="apelido">{{ apelido }}</option>
                    </select>
                </div>
                <div class="input-field" v-if="nomeEmpresa != 'GENIAL'">
                    <label for="password">Senha</label>
                    <input type="password" v-model="loginSession.Senha" class="field" autocomplete="off"
                        @click.stop.prevent="clear" :class="{ erroBorder: erro }" />
                </div>
                <button type="button" @click="reenviarEmail" v-if="habilitarReenviarEmail"
                    class="button buttonReenviarEmail">Reenviar e-mail para ativação</button>
                <router-link class="forgot-password" v-if="nomeEmpresa != 'GENIAL'" to="/RecuperarSenha">Esqueci minha
                    senha</router-link>
                <button type="submit" v-if="nomeEmpresa != 'GENIAL'" :disabled="disableBtnLogin"
                    :class="{ disabledBtn: disableBtnLogin }" class="submit-button-login">
                    <span class="btnText" v-if="!disableBtnLogin">Entrar</span>
                    <div class="loadingDots" v-if="disableBtnLogin">
                        <span class="dot">.</span>
                        <span class="dot2">.</span>
                        <span class="dot3">.</span>
                    </div>
                </button>
                <button type="button" @click="sendLogin()" v-if="nomeEmpresa == 'GENIAL'" :disabled="disableBtnLogin"
                    :class="{ disabledBtn: disableBtnLogin }" class="submit-button-login">
                    <span class="btnText" v-if="!disableBtnLogin">Avançar</span>
                    <div class="loadingDots" v-if="disableBtnLogin">
                        <span class="dot">.</span>
                        <span class="dot2">.</span>
                        <span class="dot3">.</span>
                    </div>
                </button>
            </fieldset>
        </form>
        <form v-if="tab === 3 && !openToken" class="form" @submit.stop.prevent="sendLogin">
            <fieldset :disabled="loading" style="border: none">
                <div class="input-field">
                    <label for="email">E-mail ou CNPJ</label>
                    <input type="text" v-model="loginSession.Usuario" class="field" autocomplete="off"
                        @click.stop.prevent="clear" @blur="handleEmailBlur" :class="{ erroBorder: erro }"
                        ref="emailField3" />
                </div>
                <div class="input-field" v-if="configuracaoApelido == 'S'">
                    <label for="apelido">Selecione o apelido da conta para logar</label>
                    <select v-model="loginSession.Apelido" class="field" :class="{ erroBorder: erro }"
                        style="margin-bottom: 20px;" :disabled="isApelidoDisabled">
                        <option v-for="apelido in apelidos" :key="apelido" :value="apelido">{{ apelido }}</option>
                    </select>
                </div>
                <div class="input-field">
                    <label for="password">Senha</label>
                    <input type="password" v-model="loginSession.Senha" class="field" autocomplete="off"
                        @click.stop.prevent="clear" :class="{ erroBorder: erro }" />
                </div>
                <button type="button" @click="reenviarEmail" v-if="habilitarReenviarEmail"
                    class="button buttonReenviarEmail">Reenviar e-mail para ativação</button>
                <router-link class="forgot-password" to="/RecuperarSenha">Esqueci minha senha</router-link>
                <button type="submit" :disabled="disableBtnLogin" :class="{ disabledBtn: disableBtnLogin }"
                    class="submit-button-login">
                    <span class="btnText" v-if="!disableBtnLogin">Entrar</span>
                    <div class="loadingDots" v-if="disableBtnLogin">
                        <span class="dot">.</span>
                        <span class="dot2">.</span>
                        <span class="dot3">.</span>
                    </div>
                </button>
            </fieldset>
        </form>
        <form class="form" v-if="openToken" @submit.stop.prevent="sendLoginWithToken">
            <div class="input-field">
                <label for="password">Chave de acesso</label>
                <input type="password" v-if="!configuracaoDuplaAutenticacao" v-model="loginSession.Senha" class="field" autocomplete="off"
                    @click.stop.prevent="clear" :class="{ erroBorder: erro }" />

                 <input type="password" v-if="configuracaoDuplaAutenticacao" v-model="loginSession.Token" class="field" autocomplete="off"
                    @click.stop.prevent="clear" :class="{ erroBorder: erro }" />
            </div>
            <button type="button" @click="sendLoginWithToken()" v-if="nomeEmpresa == 'GENIAL' || configuracaoDuplaAutenticacao"
                :disabled="disableBtnLogin" :class="{ disabledBtn: disableBtnLogin }" class="submit-button-login">
                <span class="btnText" v-if="!disableBtnLogin">Avançar</span>
                <div class="loadingDots" v-if="disableBtnLogin">
                    <span class="dot">.</span>
                    <span class="dot2">.</span>
                    <span class="dot3">.</span>
                </div>
            </button>
        </form>
        <div class="footer" v-if="nomeEmpresa != 'GENIAL'">
            <p>Ainda não possui conta? <router-link to="/CadastroInicio">Cadastre-se</router-link></p>
        </div>
        <ModalAvisoLogin :mensagem="messageError" :mensagensComplementares="mensagensComplementares" />
        <ModalAvisoPersonalizadoGenial v-if="nomeEmpresa == 'GENIAL' && configuracaoModalAprovacaoPersonalizada" />

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import api from '@/api/axios';
import ModalAvisoLogin from './Login/ModalAvisoLogin.vue'
import ModalAvisoPersonalizadoGenial from './Login/ModalMensagemPersonalizadaAprovacao.vue'

// Constantes para validação
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const CNPJ_REGEX = /^(\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})$/;

export default {
    name: 'UserLogin',
    components: {
        ModalAvisoLogin,
        ModalAvisoPersonalizadoGenial
    },
    data() {
        return {
            tab: 1,
            loginSession: {
                Usuario: null,
                Senha: null,
                Token: null,
                Hash: null,
                Apelido: null
            },
            apelidos: [],
            disableBtnLogin: false,
            messageError: null,
            mensagensComplementares: false,
            erro: false,
            openToken: false,
            habilitarReenviarEmail: false,
            nomeEmpresa: '',
            loading: false,
            tiposClientes: [],
            configuracaoTiposClientes: {},
            configuracaoDuplaAutenticacao: false,
            configuracaoModalAprovacaoPersonalizada: false,
            configuracaoURLEntrar: '',
            configuracaoApelido: '',
            isApelidoDisabled: false,
            isMobile: false
        };
    },
    computed: {
        ...mapGetters({
            getConfiguracoes: 'GET_CONFIGURACOES',
        }),
        mensagemLoginHeader(){
            return process.env.VUE_APP_MENSAGEM_LOGIN_HEADER;
        },
        possuiLogoEsquerdaTopo(){
            return process.env.VUE_APP_POSSUI_LOGO_ESQUERDA == 1 ? true : false
        },
        logoUrl() {
            return require('@/' + process.env.VUE_APP_URL_LOGO);
        },
        possuiBotaoCadastroTopo(){
            return process.env.VUE_APP_POSSUI_BOTAO_CADASTRAR_TOPO == 1 ? true : false
        },
        centralizarLogin(){
            return process.env.VUE_APP_CENTRALIZAR_LOGIN == 1 ? true : false
        },
        // Propriedades computadas para melhorar legibilidade
        isGenial() {
            return this.nomeEmpresa === 'GENIAL';
        },
        isRJI() {
            return this.nomeEmpresa === 'RJI';
        },
        isActual() {
            return this.nomeEmpresa === 'ACTUAL';
        },
        isDnwaysOrBritech() {
            return this.nomeEmpresa === 'BRITECH' || 
                  this.nomeEmpresa === 'DNWAYS_DEMO_Y' || 
                  this.nomeEmpresa === 'DNWAYS_DEMO_X';
        },
        isVortex() {
            return this.nomeEmpresa === 'Vortex';
        },
        isLastro() {
            return this.nomeEmpresa === 'Lastro';
        },
        showApelidoField() {
            return this.configuracaoApelido === 'S';
        },
        activeEmailField() {
            return this.tab === 1 ? 'emailField1' : 
                   this.tab === 2 ? 'emailField2' : 'emailField3';
        },
        useDuploFator() {
            return this.configuracaoDuplaAutenticacao;
        }
    },
    mounted() {
        this.disableBtnLogin = false;
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        this.isMobile = window.innerWidth <= 768;
        this.tab = this.nomeEmpresa != 'GENIAL' ? 1 : 2;
        this.$store.commit('SET_MODAL_AVISO_APROVACAO_PERSONALIZADA', false)

    },
    async created() {
        await this.fetchConfiguracao(['Remover tipo de cadastro', 'Habilitar duplo fator na autenticação', 'Modal de aprovação personalizada', 'Redirecionamento do botão entrar Onboarding externo', 'Exibir apelido']);
        this.configuracaoTiposClientes = this.getConfiguracoes('Remover tipo de cadastro');
        this.configuracaoDuplaAutenticacao = this.getConfiguracoes('Habilitar duplo fator na autenticação')?.Valor == 'S' ? true : false;
        this.configuracaoModalAprovacaoPersonalizada = this.getConfiguracoes('Modal de aprovação personalizada')?.Valor == 'S' ? true : false;
        this.configuracaoURLEntrar = this.getConfiguracoes('Redirecionamento do botão entrar Onboarding externo').Valor;
        this.configuracaoApelido = this.getConfiguracoes('Exibir apelido').Valor;
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            verifyLogin: 'auth/verifyLogin',
            verifyStatusRegister: 'auth/verifyStatusRegister',
            fetchConfiguracao: 'FETCH_CONFIGURACOES'
        }),
        /**
         * Métodos utilitários para exibição de modais e tratamento de UI
         */
        avisoLogin() {
            this.$store.commit('SET_MODAL_AVISO_LOGIN', true)
        },
        avisoLoginAprovadoPersonalizado() {
            this.$store.commit('SET_MODAL_AVISO_APROVACAO_PERSONALIZADA', true)
        },
        voltar() {
            this.resetLoginSession();
            this.openToken = false;
        },
        resetLoginSession() {
            this.loginSession = {
                Usuario: null,
                Senha: null,
                Token: null,
                Hash: null,
                Apelido: null
            };
        },
        /**
         * Exibe mensagem de erro padrão e atualiza estado do componente
         */
        exibirErro(mensagem, exibirModal = true) {
            this.disableBtnLogin = false;
            this.messageError = mensagem || 'Ocorreu um erro desconhecido. Entre em contato com o suporte.';
            this.erro = true;
            if (exibirModal) {
                this.avisoLogin();
            }
            return false;
        },
        /**
         * Trata resposta de erro da API
         */
        tratarErroResposta(error, exibirModal = true) {
            this.disableBtnLogin = false;
            
            // Verifica se é erro de e-mail não validado
            if (error.response?.data?.data?.[0] === 'Cliente com e-mail não validado!') {
                this.habilitarReenviarEmail = true;
            }

            // Modal personalizado para Genial
            if (error.response?.data?.data === 'MODAL_APROVACAO_PERSONALIZADA' && this.configuracaoModalAprovacaoPersonalizada) {
                this.avisoLoginAprovadoPersonalizado();
                return;
            }

            // Diferentes tipos de erro
            if (!error.response || !error.response.data) {
                return this.exibirErro('Falha na autenticação. Entre em contato com o suporte.', exibirModal);
            } else if (error.response.data.data && Array.isArray(error.response.data.data) && error.response.data.data.length > 0) {
                this.mensagensComplementares = error.response.data.data.length > 1;
                return this.exibirErro(error.response.data.data[0], exibirModal);
            } else {
                return this.exibirErro(null, exibirModal);
            }
        },
        /**
         * Limpa mensagens de erro
         */
        clear() {
            this.messageError = '';
            this.erro = false;
        },
        /**
         * Validação de entrada do usuário
         */
        validarEntrada() {
            if (!this.loginSession.Usuario) {
                this.exibirErro('Verifique os dados.');
                return false;
            }
            
            if (this.isGenial) {
                const usuario = this.loginSession.Usuario;
                if (!EMAIL_REGEX.test(usuario) && !CNPJ_REGEX.test(usuario)) {
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `O CNPJ/E-mail informado não foi encontrado ou é inválido! Verifique os dados e tente novamente.`,
                    });
                    this.erro = true;
                    return false;
                }
                return true;
            }

            if (!this.loginSession.Senha) {
                this.exibirErro('Verifique os dados.');
                return false;
            }
            
            if (this.showApelidoField && this.tab !== 1 && !this.loginSession.Apelido) {
                this.exibirErro('Verifique os dados.');
                return false;
            }
            
            return true;
        },
        async verificarStatusCadastro() {
            var model = { Usuario: this.loginSession.Usuario }
            await this.verifyStatusRegister(model)
                .then(response => {
                    this.disableBtnLogin = false;
                    console.log(response.data.data);
                    if (response.data.data == null) {
                        this.$router.push({ name: 'CadastroInicio' });
                    }
                    else if(response.data?.data?.StatusCadastro == 2 && this.nomeEmpresa == 'GENIAL'){
                        this.avisoLoginAprovadoPersonalizado();
                    }
                    else if (response.data.data.StatusCadastro == 0) {
                        this.messageError = '';
                        this.erro = false;
                        this.openToken = true;
                    } else if (response.data.data.StatusCadastro == 1
                        || (response.data.data.StatusCadastro == 4 && !response.data.data.PermiteLoginEmRevisao)) {
                        this.messageError = '';
                        this.erro = false;
                        this.disableBtnLogin = false;
                        this.$swal({
                            icon: 'warning',
                            title: 'Cadastro em análise!',
                            text: 'Estamos analisando os dados recebidos. Em breve você receberá novidades no e-mail informado.',
                        });
                        return;
                    } else {
                        window.location.href = this.configuracaoURLEntrar;
                    }
                })
                .catch((error) => {
                    this.disableBtnLogin = false;
                    console.log(error);
                    if (error.response.data == '') {
                        this.messageError = 'Falha na autenticação. Entre em contato com o suporte.';
                        this.avisoLogin();
                        this.erro = true;
                    } else if (error.response.data && error.response.data.data) {
                        if(error.response.data.data.codeErro == 2)
                        {
                            this.$swal({
                                icon: 'warning',
                                title: 'Cadastro em análise!',
                                text: 'Estamos analisando os dados recebidos. Em breve você receberá novidades no e-mail informado.',
                            });

                        }else{
                            this.messageError = error.response.data.data.erros[0];
                            if (error.response.data.data.erros.length > 1) {
                                this.mensagensComplementares = true;
                            }
                            this.avisoLogin();
                            this.erro = true;
                        }
                    } else {
                        this.messageError = 'Ocorreu um erro desconhecido. Entre em contato com o suporte.';
                        this.avisoLogin();
                        this.erro = true;
                    }
                });
        },
        verificarTipoCliente(tipo) {
            return this.tiposClientes.some(cliente => Number(cliente.value) === Number(tipo));
        },
        selectTab(index) {
            this.tab = index;
            this.$nextTick(() => {
                if (!this.isMobile) {
                    if (this.tab === 1) {
                        this.$refs.emailField1?.focus();
                    } else if (this.tab === 2) {
                        this.$refs.emailField2?.focus();
                    } else if (this.tab === 3) {
                        this.$refs.emailField3?.focus();
                    }
                }
            });
        },
        async handleEmailBlur() {
            if (!this.loginSession.Usuario) {
                this.apelidos = [];
                return;
            }
            this.loading = true;
            try {
                if (this.configuracaoApelido == 'S') {
                    const response = await api.get('/login', {
                        params: { chaveLogin: this.loginSession.Usuario, tipoCliente: this.tab },
                    });
                    this.apelidos = response.data.data;
                    if (this.loginSession.Usuario.includes('@')) {
                        this.loginSession.Apelido = null;
                        this.isApelidoDisabled = false;
                    } else {
                        this.loginSession.Apelido = this.apelidos.length > 0 ? this.apelidos[0] : null;
                        this.isApelidoDisabled = true;
                    }
                }
            } catch (error) {
                this.apelidos = null;

                if(error.response.data.descricao){
                    this.messageError = error.response.data.descricao;
                    this.avisoLogin();
                    this.erro = true;
                    this.disableBtnLogin = false;
                }

                console.error('Erro ao buscar apelidos:', error);
            } finally {
                this.loading = false;
            }
        },
        irParaCadastroInicial() {
            this.$router.push({ name: 'CadastroInicio' });
        },
        async reenviarEmail() {
            if (this.loginSession.Usuario == '') {
                this.messageError = 'Verifique os dados';
                this.erro = true;
                return;
            }
            var model = { Email: this.loginSession.Usuario }
            await api
                .post('/register/email-ativar-conta', model)
                .then((retorno) => {
                    if (!retorno.data) {
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Falha no envio do e-mail. Verifique as credenciais de acesso.`,
                        });
                    }
                    else {
                        this.habilitarReenviarEmail = false;
                        this.messageError = '';
                        this.erro = false;
                        this.$swal({
                            icon: 'success',
                            title: 'E-mail enviado!',
                            text: 'Acesse o e-mail cadastrado para confirmar seu acesso.',
                        }).then((result) => {
                            if (result.value) {
                                this.$router.push({ name: 'UserLogin' });
                            }
                        });
                    }
                })
                .catch((error) => {
                    this.disableBtn = false;
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `${error.response.data.descricao}`,
                    });
                });
        },
        async sendLoginWithToken() {
            this.disableBtnLogin = true;
            var model = { Usuario: this.loginSession.Usuario, Senha: this.loginSession.Senha, Token: this.loginSession.Token ?? this.loginSession.Senha, Apelido: this.loginSession.Apelido, TipoCliente: this.tab, HashToken: this.loginSession.Hash }
            
            await this.signIn(model)
                .then(response => {
                    this.disableBtnLogin = false;
                    if (response.status == 200) {
                        this.messageError = '';
                        this.erro = false;
                        this.$router.replace({
                            path: '/',
                        });
                    }
                })
                .catch(() => {
                    this.disableBtnLogin = false;
                    this.erro = true;
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `O Token informado não é válido! Verifique e tente novamente.`,
                    });

                });
        },
        async sendLogin() {
            this.disableBtnLogin = true;
            this.habilitarReenviarEmail = false;
            this.erro = false;
            this.mensagensComplementares = false;
            if (this.nomeEmpresa == 'GENIAL') {
                const usuario = this.loginSession.Usuario;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const cnpjRegex = /^(\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})$/;
                if (!usuario || (!emailRegex.test(usuario) && !cnpjRegex.test(usuario))) {
                    this.messageError = 'Verifique os dados';
                    this.erro = true;
                    this.disableBtnLogin = false;
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `O CNPJ/E-mail informado não foi encontrado ou é inválido! Verifique os dados e tente novamente.`,
                    });
                    return;
                }
            }
            if ((this.loginSession.Usuario == '' || this.loginSession.Usuario == null) && !this.isGenial) {
                this.messageError = 'Verifique os dados.';
                this.avisoLogin();
                this.erro = true;
                this.disableBtnLogin = false;
                return;
            } else if ((this.loginSession.Senha == '' || this.loginSession.Senha == null) && !this.isGenial) {
                this.messageError = 'Verifique os dados.';
                this.avisoLogin();
                this.erro = true;
                this.disableBtnLogin = false;
                return;
            } else if (this.configuracaoApelido == 'S' && this.tab != 1 && (this.loginSession.Apelido == '' || this.loginSession.Apelido == null) && !this.isGenial) {
                this.messageError = 'Verifique os dados.';
                this.avisoLogin();
                this.erro = true;
                this.disableBtnLogin = false;
                return;
            }
            if (this.isGenial) {
                this.verificarStatusCadastro();
                return;
            }
            var model = { Usuario: this.loginSession.Usuario, Senha: this.loginSession.Senha, Apelido: this.loginSession.Apelido, tipoCliente: this.tab, HashToken: this.loginSession.Senha }

            if(this.configuracaoDuplaAutenticacao){
                await this.verifyLogin(model)
                .then(response => {
                    this.disableBtnLogin = false;
                    if (response.status == 200) {
                        console.log(response.data);
                        this.loginSession.Hash = response.data.data.HashToken;
                        this.messageError = '';
                        this.erro = false;
                        this.openToken = true;
                    }
                })
                .catch((error) => {
                    this.disableBtnLogin = false;

                    if(error.response.data?.data[0] == 'Cliente com e-mail não validado!'){
                        this.habilitarReenviarEmail = true;
                    }

                    if (error.response.data == '') {
                        this.messageError = 'Falha na autenticação. Entre em contato com o suporte.';
                        this.avisoLogin();
                        this.erro = true;
                    } else if (error.response.data && error.response.data.data && error.response.data.data.length > 0) {
                        this.messageError = error.response.data.data[0];
                        if (error.response.data.data.length > 1) {
                            this.mensagensComplementares = true;
                        }
                        this.avisoLogin();
                        this.erro = true;
                    } else {
                        this.messageError = 'Ocorreu um erro desconhecido. Entre em contato com o suporte.';
                        this.avisoLogin();
                        this.erro = true;
                    }
                });
            }else{
            await this.signIn(model)
                .then(response => {
                    this.disableBtnLogin = false;
                    if (response.status == 200) {
                        this.messageError = '';
                        this.erro = false;
                        this.$router.replace({
                            path: '/',
                        });
                    }
                })
                .catch((error) => {
                    this.disableBtnLogin = false;

                   if(error.response.data?.data[0] == 'Cliente com e-mail não validado!'){
                        this.habilitarReenviarEmail = true;
                    }



                    if (error.response.data == '') {
                        this.messageError = 'Falha na autenticação. Entre em contato com o suporte.';
                        this.avisoLogin();
                        this.erro = true;
                    }else if(error.response.data?.data == 'MODAL_APROVACAO_PERSONALIZADA' && this.configuracaoModalAprovacaoPersonalizada){
                        this.avisoLoginAprovadoPersonalizado();
                    }else if (error.response.data && error.response.data.data && error.response.data.data.length > 0) {
                        this.messageError = error.response.data.data[0];
                        if (error.response.data.data.length > 1) {
                            this.mensagensComplementares = true;
                        }
                        this.avisoLogin();
                        this.erro = true;
                    } else {
                        this.messageError = 'Ocorreu um erro desconhecido. Entre em contato com o suporte.';
                        this.avisoLogin();
                        this.erro = true;
                    }
                });
            }
        },
    },
    watch: {
        configuracaoTiposClientes(newVal) {
            if (newVal && newVal.Valor) {
                const valores = newVal.Valor.replace('\r\n', ';').replace(',', ';').split(';').map(item => item.trim()).filter(item => item);
                const todasOpcoes = [
                    { value: '1', label: 'Pessoa Física' },
                    { value: '2', label: 'Pessoa Jurídica' },
                    { value: '3', label: 'Fundo de Investimento' }
                ];
                const tiposFiltrados = todasOpcoes.filter(opcao => !valores.includes(opcao.value));
                if (JSON.stringify(tiposFiltrados) !== JSON.stringify(this.tiposClientes)) {
                    this.tiposClientes = tiposFiltrados;
                }
            } else {
                if (this.tiposClientes.length > 0) {
                    this.tiposClientes = [];
                }
            }
            if (this.tiposClientes.length > 0) {
                this.tab = parseInt(this.tiposClientes[0].value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

body,
html {
    height: 100%;
    margin: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo {
    position: relative;
    display: inline-block;
}

.logoHeader {
    height: 100% !important;
    width: 100% !important;
    height: auto;
    display: block;
    position: relative;
    z-index: 1;
}

.logoHeader_rji {
    height: auto;
    display: block;
    position: relative;
    z-index: 1;
    height: 60% !important;
    width: 60% !important;
}

.logo-rji {
    position: relative;
    display: inline-block;
}

.logo-image-actual {
    height: 100% !important;
    width: 100% !important;
    height: auto;
    display: block;
    position: relative;
    z-index: 1;
}

@keyframes shine {
    0% {
        left: -100%;
    }

    100% {
        left: 100%;
    }
}

@keyframes shine_rji {
    0% {
        left: -100%;
    }

    100% {
        left: 50%;
    }
}

.site-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0rem 2rem;
    background-color: #fff;
}

.siteHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 5em;
    padding: 0rem 2rem;
    background-color: rgba(255, 255, 255, 0.5) !important;
}

.siteHeaderRJI {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 2rem;
    background-color: rgba(15, 37, 71, 0.5) !important;
}

.siteHeaderActual {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo img {
    height: 32px;
    width: 142px;
}

.navigation ul {
    list-style: none;
    display: flex;
    gap: 1rem;
}

.submit-button-login {
    width: 100%;
    padding: 0.5rem;
    color: white;
    border: none;
    cursor: pointer;
    background: #03204f;
    text-align: center;
    border: 1px solid #5E84C3;
    border-radius: 8px;
}

.navigation li {
    padding: 0.5rem 1rem;
}

.navigation a {
    text-decoration: none;
    color: #000;
}

.navigation a.router-link-active {
    color: #00235C;
}

.buttonReenviarEmail {
    cursor: pointer;
    margin-bottom: 10px;
}

.navigation a.router-link-exact-active {
    background-color: #00235C;
    color: #fff;
    border-radius: 5px;
    padding: 0.5rem 1rem;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    padding-top: 0px;
    border-radius: 10px;
    background-color: white;
    border-radius: 8px;
}

.containerDesktop {
    background-color: rgba(255, 255, 255, 0.5) !important;
    padding-top: 3em;
    height: 100vh;
    width: 30vw;
    position: absolute;
    top: 0;
    right: 0;
}

.containerActual {
    background-color: rgba(37, 36, 87, 0.5) !important;
    color: #FFF;
    height: 100vh;
    width: 30vw;
    position: absolute;
    top: 0;
    right: 0;

    .forgot-password{
        color: rgba(37, 36, 87, 0.5) !important;
        cursor: pointer !important;
    }
}

.containerRJI {
    background-color: rgba(15, 37, 71, 0.5) !important;
    color: #FFF;
    height: 100vh;
    width: 30vw;
    position: absolute;
    top: 0;
    right: 0;
}

.containerRJI h2 {
    color: #FFF !important;
}

.containerRJI p {
    color: #FFF !important;
}

.containerRJI label {
    color: #00235C !important;
}

.containerRJI .forgot-password {
    color: #00235C !important;
    font-weight: 800;
}

.containerRJI .link{
    color: #FFF !important;
}

.containerRJI .tab-item{
    color: #FFF !important;
    font-weight: 800;
}

.containerRJI .footer a{
   color: #FFF !important;
}

.containerActual h2 {
    color: #FFF !important;
}

.containerActual p {
    color: #FFF !important;
}


.containerActual  a {
    color: #FFF !important;
    font-weight: 800;
}

.logomark {
    width: 54px;
    height: 43.2px;
}

.header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
}

.header h2 {
    width: 360px;
    height: 38px;
    font-family: 'Gabarito', sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 38px;
    text-align: center;
    margin: 0 auto;
    color: #101828;
    margin-top: 20px;
}

.header p {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #6E6E6E;
}

.footer p {
    font-family: 'Inter', sans-serif;
    color: #667085;
    font-size: 16px;
    line-height: 24px;
}

.footer a {
    font-weight: 600;
    color: #101828;
    text-decoration: none;
}

button {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
}

.entrar-button {
    color: #667085;
    background: white;
    cursor: pointer;
}

input {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px;
    margin-bottom: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-sizing: border-box;
    width: 100%;
}

.erroBorder {
    border: 1px solid #E73D3D !important;
    margin-bottom: 16px;
}

.erroBorderVerifyRegister {
    border: 1px solid #E73D3D !important;
    margin-bottom: 10px;
}

.erro {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    color: #E73D3D;
    max-width: 360px;
}

.form .input-field label {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #344054;
}

form {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 8px;
    width: calc(130px * 3 + 40px * 2);
}

input {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

button {
    padding: 10px;
    background-color: #00235C;
    ;
    color: white;
    border: none;
    border-radius: 4px;
    text-align: center;
}

@media (max-width: 600px) {
    .login-container {
        margin: 20px;
        padding: 10px;
    }

    input,
    button {
        margin-bottom: 10px;
    }
}

h2 {
    text-align: center;
    margin-bottom: 20px;
}

.forgot-password {
    font-family: 'Inter', sans-serif;
    display: block;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
    color: #00064F;
    text-decoration: none;
}

.signup {
    text-align: center;
    margin-top: 20px;
}

.signup a {
    color: blue;
    text-decoration: none;
}

.tabs-container {
    display: flex;
    justify-content: center;
    position: relative;
    border-bottom: 2px solid #D3D3D3;
}

.tab-item {
    position: relative;
    min-width: 130px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-left: 20px;
}

.tab-item .link {
    display: inline-block;
    padding: 10px;
    color: rgb(1, 1, 68);
    text-decoration: none;
    margin-left: 18px;
    font-weight: bold;
    width: 100%;
}

.tab-item .underline {
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 2px;
    background-color: transparent;
    transition: background-color 0.3s;
}

.tab-item.active .link {
    color: rgb(1, 1, 68);
}

.tab-item.active .underline {
    background-color: rgb(1, 1, 68);
    margin-left: -18px;
}
</style>
